import type {
    LeadDetailedResultsRequestDto,
    LeadsDetailedResultsResponseDto,
} from "app/pages/sales-intelligence/modules/leads-search/types";
import type { IFetchService, PostConfigObject } from "app/services/fetchService";

import { BASE_ENDPOINT_PATH } from "./const";

/**
 * Service for all "websites"-based endpoints
 */
export const createWebsitesApiService = (fetchService: IFetchService) => {
    const baseWebsitesPath = `${BASE_ENDPOINT_PATH}/websites`;

    return {
        fetchDetailedResults(
            dto: LeadDetailedResultsRequestDto,
            config?: PostConfigObject,
        ): Promise<LeadsDetailedResultsResponseDto> {
            return fetchService.post<LeadsDetailedResultsResponseDto>(`${baseWebsitesPath}/details`, dto, config);
        },
    };
};
